import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { encodeForURI } from 'appSrc/utils';
import { Icon, Table, DLMenu } from 'appSrc/components/UI';
import { CopyDrop } from '../../Common';
import { convertImage } from 'appSrc/utils';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class SortableProductsTable extends PureComponent {
    render() {
        const { products } = this.props;

        return (
            <div>
                <Table
                className={ style.productsTable }
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    <Table.Head>
                        <Table.Row draggable={ false }>
                            <Table.Cell></Table.Cell>
                            <Table.Cell style={ { minWidth: '100px' } }></Table.Cell>
                            <Table.Cell>PRODUCT TITLE</Table.Cell>
                            <Table.Cell>AUTHOR</Table.Cell>
                            <Table.Cell></Table.Cell>
                            <Table.Cell>ACTIONS</Table.Cell>
                        </Table.Row>
                    </Table.Head>
                    <Table.SortableBody onChange={ this.props.onSort }>
                        { this.arrayTableRows( products ) }
                    </Table.SortableBody>
                </Table>
            </div>
        );
    }

    arrayTableRows = ( products ) => {
        var rows = products.map( ( product, index ) => {
            var individualSlug = `/admin/products/${ product.desireid }`;
            var publicSlug = `${ window.location.origin }/app/products/${ product.desireid }/${ encodeForURI(product.title) }`;
            var author = product.author || {};
            return (
                <Table.Row key={ product.desireid }>
                    <Table.Cell className='handle' style={ { cursor: 'grab' } }>
                        <Icon source='fontAwesome' icon='fas/faArrowsAltV' style={ { color: 'inheirit' } } />
                    </Table.Cell>
                    <Table.Cell className={ style.coverImage }>
                        <Link to={ individualSlug }></Link>
                        <img src={ convertImage( product.image, '/100x100' ) } style={ { height: '80px' } } />
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ individualSlug }></Link>
                        { product.title }
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ `/admin/users/${ author.userid }` }></Link>
                        { author.displayName }
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <CopyDrop content={ publicSlug } />
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Remove'
                            onClick={ () => {
                                this.props.removeProduct( index );
                            } }/>
                        </DLMenu>
                    </Table.Cell>
                </Table.Row>
            );
        } );

        return rows;
    }
}
SortableProductsTable.defaultProps = {
    onProductUpdated: ()=>{},
};

export default connect()( SortableProductsTable );
